import {createGlobalStyle} from 'styled-components';

import './app.scss'

// build version number, display after trooper build after deploy to demo|qa|live
export const BoilerplateGlobals = createGlobalStyle`
  .version-number {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 10;
    color: #aaa;
    font-size: 9px;
  }
`;
